var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.pageLoad),expression:"pageLoad"}]},[_c('OmsForm',{ref:"matrixForm",attrs:{"formConfig":_vm.formConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }